var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { cx, css as emotionCss } from 'emotion';
import { ButtonGroup, SecondaryButton, styles, stylesCitron } from '@citrus/button';
import { useTheme } from '@citrus/user';
import { ButtonRating as Component } from './Rating.styled';
import * as ratingStylesLegacy from '../styles/legacy';
import * as ratingStylesCitron from '../styles/citron';
import { getAutomation, getDebug, useMobile } from '@citrus/runtime';
import { isNotNullOrEmpty } from '@pcty/utils';
var VERSION = '4.0.0-CDS4220.0';
var ButtonRating = React.forwardRef(function (_a, ref) {
    var _b;
    var automationId = _a.automationId, className = _a.className, css = _a.css, _c = _a.items, items = _c === void 0 ? [] : _c, _d = _a.value, value = _d === void 0 ? 0 : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, onItemClick = _a.onItemClick, _f = _a.__TYPE, __TYPE = _f === void 0 ? 'ButtonRating' : _f, other = __rest(_a, ["automationId", "className", "css", "items", "value", "disabled", "onItemClick", "__TYPE"]);
    var isCitron = useTheme().citrus2022;
    var _g = useState(value), selectedValue = _g[0], setSelectedValue = _g[1];
    var isMobile = useMobile(700);
    var classes = cx((_b = {},
        _b[emotionCss(css)] = isNotNullOrEmpty(css),
        _b), className || '');
    var ratingStyles = isCitron ? ratingStylesCitron.buttonRating : ratingStylesLegacy.buttonRating;
    var selectedStyles = isCitron ? stylesCitron.selectedSecondary : styles.hoverSecondary;
    var buttonClicked = function (item) {
        if (disabled)
            return;
        setSelectedValue(item.value);
        if (onItemClick)
            onItemClick(item);
    };
    var isSelected = function (item) {
        return selectedValue && item && item.value && item.value.toString() === selectedValue.toString();
    };
    var setSelectedStyle = function (item) { return (__assign(__assign({}, (isSelected(item) ? selectedStyles : undefined)), ratingStyles)); };
    var buttons = [];
    if (items) {
        items.map(function (item) {
            buttons.push(React.createElement(SecondaryButton, { css: setSelectedStyle(item), disabled: disabled && !isSelected(item), key: "key-rating-".concat(item.value), onClick: function () { return buttonClicked(item); }, style: { marginLeft: '0px' } }, item.label));
        });
    }
    return (React.createElement(Component, __assign({ className: classes, ref: ref }, other, getAutomation(automationId), getDebug(sessionStorage.getItem('citrus-debug') === 'true', __TYPE, VERSION)), isMobile ? buttons : React.createElement(ButtonGroup, { fullWidth: true }, buttons)));
});
ButtonRating.defaultProps = {
    __TYPE: 'ButtonRating',
};
export default ButtonRating;
